import { useState } from 'react';
import { CalendarPlusIcon } from 'lucide-react';
import { Panel } from '../ui/Panel';
import { Field } from '../ui/Field';
import { CustomerTimeChoice } from './CustomerTimeChoice';
import { useAdmin } from '../AdminContext';
import { btnSecondary, inputCls } from '../ui/styles';
import { useRequestId } from '../../hooks/useRequestId';
import { courseStatus } from '../../utils/account';
import type { CustomerFileControl } from './useCustomerFile';

/** Door Sarah ingepland = direct bevestigd. Hoort het bij de lopende kuur, dan krijgt het het sessienummer mee. */
export function NewAppointment({
  ctl
}: {
  ctl: CustomerFileControl;
}) {
  const {
    catalog,
    index
  } = useAdmin();
  const status = courseStatus(ctl.file.account);
  const [open, setOpen] = useState(false);
  const [slug, setSlug] = useState(status?.course.treatmentSlug ?? catalog.treatments[0]?.slug ?? '');
  const [when, setWhen] = useState<{
    date: string;
    time: string;
  }>({
    date: '',
    time: ''
  });
  const [sending, setSending] = useState(false);
  const courseSession = status?.course.treatmentSlug === slug && status.nextToBook || undefined;
  const courseTotal = status?.course.total;
  const treatment = index.treatmentBySlug(slug);
  // Eén id per inhoud: een dubbele tik of opnieuw proberen na een netwerkfout maakt nooit twee afspraken.
  const requestId = useRequestId(JSON.stringify([ctl.file.account.customer.id, slug, when.date, when.time, courseSession ?? null]));
  if (!open) {
    return <button type="button" onClick={() => setOpen(true)} className={btnSecondary} data-id="element-1481" data-mp="35j88rktxmvf2">
        <CalendarPlusIcon className="h-4 w-4" strokeWidth={1.75} aria-hidden="true" data-id="element-1482" data-mp="39kk0bvwd9qpw" />
        Afspraak inplannen
      </button>;
  }
  const confirm = async (date: string, time: string) => {
    if (sending) return;
    setSending(true);
    const ok = await ctl.addAppointment({
      requestId,
      treatmentSlug: slug,
      date,
      time,
      kind: treatment?.online ? 'video' : 'salon',
      session: courseSession
    });
    setSending(false);
    if (ok) setOpen(false);
  };
  return <Panel title="Afspraak inplannen" description="Door jou ingepland = direct bevestigd. De klant krijgt een bericht." data-id="element-1483" data-mp="3u4yau97a8lcn">
      <Field label="Behandeling" data-id="element-1484" data-mp="6tqiu0k2b813">
        <select value={slug} onChange={e => setSlug(e.target.value)} className={inputCls} disabled={sending} data-id="element-1485" data-mp="6sx86ohzfydo">
          {catalog.treatments.map(t => <option key={t.slug} value={t.slug} data-id="element-1486" data-mp="3b86uo8n1emct">
              {t.name} · {t.durationMinutes} min
            </option>)}
        </select>
      </Field>
      {courseSession && <p className="mt-2 text-[13px] text-muted" data-id="element-1487" data-mp="36bgellb8fqre">
          Wordt sessie {courseSession} van {courseTotal} van de kuur.
        </p>}
      <div className="mt-4" data-id="element-1488" data-mp="3f9iiq9q9iziw">
        <CustomerTimeChoice durationMinutes={treatment?.durationMinutes ?? 60} confirmLabel={w => `Inplannen op ${w}`} busy={sending} onChange={(date, time) => setWhen({
        date,
        time
      })} onConfirm={(date, time) => void confirm(date, time)} onCancel={() => setOpen(false)} data-id="element-1489" data-mp="3f88mlq2z01ew" />
      </div>
    </Panel>;
}